/* Built In Imports */
import { useState } from 'react';

/* External Imports */
import { Box, Center, Heading, Image, Text } from '@chakra-ui/react';
import Slider from 'react-slick';

/** Styles */
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
/* Services */

/**
 * MeditationSlider Component
 * @param {Object} section dato
 * @param {String} region
 * @param {String} lang
 * @returns {ReactElement} MeditationSlider Component
 */
/**
 *
 * @param {Object} param0
 * @returns
 */
export const MomHeading = ({ text, ...props }) => {
  return (
    <Center
      flexDir="column"
      px="20px"
      textAlign="center"
      mx="auto"
      maxW="400px"
      {...props}
    >
      {/* <Heading
      mx="auto"
      maxW="400px"
      textAlign="center"
      fontSize={{ base: '26px', md: '48px' }}
    >
      {title.titleText}
    </Heading> */}
      <Heading
        textAlign="center"
        fontFamily="'Trirong', serif"
        fontSize={{ base: '26px', md: '48px' }}
        fontWeight={400}
      >
        {text}
      </Heading>
      <Image
        src={`https://static.sadhguru.org/d/46272/1730987973-a.png`}
        w="auto"
        height="auto"
        mt="20px"
      />
    </Center>
  );
};

const MeditationSlider = ({ section, region, lang }) => {
  const [index, setIndex] = useState();
  const settings = {
    className: 'slider variable-width',
    dots: false,
    arrows: false,
    infinite: true,
    centerMode: true,
    centerPadding: '10px',
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    variableWidth: true,
    afterChange: function (index) {
      setIndex(index);
    },
    adaptiveHeight: true,
    speed: 1000,
    autoplaySpeed: 7000,
    cssEase: 'linear',
    autoplay: true,
    responsive: [
      {
        breakpoint: 10000, // to hide slider for desktop and ipad and other large screen resolutions
        settings: 'unslick',
      },
      {
        breakpoint: 1024,
        settings: {
          infinite: false,
          dots: true,
          variableWidth: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
    ],
  };
  const card_info4_column_group = section.find(
    el => el._modelApiKey === 'card_info4_column_group'
  );
  const title = section.find(el => el._modelApiKey === 'section_title');

  return (
    <Box
      pos="relative"
      mb={{ base: '30px', md: '50px', lg: '70px' }}
      pt={{ base: '40px', lg: '80px' }}
      _before={{
        content: "''",
        zIndex: -1,
        pos: 'absolute',
        top: 0,
        right: 0,
        left: 0,
        height: '70%',
        background: '#EDEDED',
      }}
    >
      <MomHeading text={title.titleText} />
      <Box mb="50px">
        {card_info4_column_group && (
          <Slider {...settings}>
            {card_info4_column_group?.cards.map(card => {
              return (
                <Center
                  flexDirection="column"
                  pt={{ base: '50px', md: '100px' }}
                  transition="all 0.2s ease-out"
                  mx={{ base: '0', xl: '15px' }}
                >
                  <Image
                    transition="transform 0.2s ease-out"
                    _hover={{
                      transform: 'scale(1.1)',
                      transformOrigin: 'bottom',
                      // mt: '-20px',
                    }}
                    width={{
                      base: '100%',
                      sm: '290px !important',
                      // md: '425px !important',
                    }}
                    // height={{ base: 560, md: 800, lg: 'auto' }}
                    src={card?.thumbnail?.url}
                    m="0 auto"
                  />
                  <Text
                    textAlign="center"
                    w="227px"
                    color="#000"
                    mx="auto"
                    fontSize="20px"
                    fontFamily="'Geist', sans-serif"
                    minH="100px"
                  >
                    {card?.title}
                  </Text>
                </Center>
              );
            })}
          </Slider>
        )}
      </Box>
      <style>
        {`
          .regular.slider {
            display: flex;
            align-items: center;
            max-width: 1330px;
            margin: 0 auto;
          }
          .slick-slide img {
            display: block !important;
          }
          .variable-width .slick-dots li button:before{
          color:#D9D9D9;
          font-size:8px;
          opacity:1;
          }
          .variable-width .slick-dots li.slick-active button:before{
          color:#EC1C2D;
          font-size:8px;
          opacity:1;
          }
          .variable-width .slick-dots{
          bottom:-55px;
          }
          `}
      </style>
    </Box>
  );
};

export default MeditationSlider;
